import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash';

import theme from './Toggle.scss';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  switchClass: PropTypes.string,
  testId: PropTypes.string,
  id: PropTypes.string,
  tabIndex: PropTypes.number,
  ariaLabel: PropTypes.string,
};

const defaultProps = {
  checked: false,
  disabled: false,
  className: '',
  switchClass: '',
  testId: '',
  id: undefined,
  tabIndex: 0,
  ariaLabel: undefined,
};

const Toggle = ({
  id,
  onChange,
  checked,
  disabled,
  className,
  switchClass,
  testId,
  tabIndex,
  ariaLabel,
}) => {
  const inputRef = useRef(null);
  const onBlur = useCallback(() => inputRef.current?.blur(), []);
  const onChangeInput = useCallback((e) => {
    if (disabled) return noop;
    return onChange(e, e.target.checked);
  }, [disabled, checked]);

  return (
    <div className={ classnames(theme.root, className) }>
      <label
        htmlFor={ id }
        className={ classnames(theme.switch, switchClass, { [theme.disabled]: disabled }) }
        onMouseLeave={ onBlur }
      >
        <input
          id={ id }
          ref={ inputRef }
          onChange={ onChangeInput }
          type="checkbox"
          checked={ checked }
          data-testid={ testId }
          aria-label={ ariaLabel }
          tabIndex={ tabIndex }
        />
        <span className={ theme.slider }>
          <span className={ theme.knobWrap } >
            <span className={ theme.knob } />
          </span>
          <span className={ theme.track } />
        </span>
      </label>
    </div>
  );
};

Toggle.propTypes = propTypes;
Toggle.defaultProps = defaultProps;

export default Toggle;
